import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type SuperAdminUser } from './types';

export const useGetUserList = (variables: {
  sort?: any;
  pagination?: any;
  filter?: any;
}): {
  users: SuperAdminUser[];
  total: number;
  loading: boolean;
  error: any;
  refetch: () => void;
} => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query (
        $filter: AdvancedUserFilter
        $pagination: AdvancedUserListPagination
      ) {
        advancedUsersListPaginated(filter: $filter, pagination: $pagination) {
          data {
            netId
            department
            displayName
            surname
            givenName
            email
            role
            updatedAt
            updatedBy
          }
          total
        }
      }
    `,
    {
      fetchPolicy: 'network-only',
      variables,
    },
  );

  return {
    users: data?.advancedUsersListPaginated?.data,
    total: data?.advancedUsersListPaginated?.total,
    loading,
    error,
    refetch,
  };
};
